const metrics = [
  { label: 'Traffic', value: '45.2K', trend: '+12.5%', icon: 'ri-user-line' },
  { label: 'Rankings', value: '#3.2', trend: '+2 spots', icon: 'ri-trophy-line' },
  { label: 'Conversions', value: '892', trend: '+18.3%', icon: 'ri-shopping-cart-line' },
  { label: 'Speed Score', value: '98', trend: '+5 pts', icon: 'ri-speed-line' }
];

const keywords = [
  { keyword: 'website design', position: 2, change: 'up' },
  { keyword: 'seo services', position: 1, change: 'same' },
  { keyword: 'web development', position: 4, change: 'up' },
  { keyword: 'digital marketing', position: 3, change: 'down' },
  { keyword: 'local seo', position: 1, change: 'up' }
];

export default function SEODashboard() {
  return (
    <section id="seo-dashboard" className="py-24 bg-[#1A1D29]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-5xl lg:text-6xl font-bold text-white mb-4">Real-Time SEO Insights</h2>
          <div className="w-24 h-1 bg-[#FF6B6B] mx-auto mb-6"></div>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Monitor your website's performance with our comprehensive analytics dashboard. Track rankings, traffic, and conversions in real-time.
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="bg-[#252936] rounded-3xl p-8 shadow-2xl relative overflow-hidden">
            <div className="absolute top-0 right-0 w-96 h-96 bg-[#FF6B6B]/10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#14B8A6]/10 rounded-full blur-3xl"></div>

            <div className="relative z-10">
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
                {metrics.map((metric, index) => (
                  <div key={index} className="bg-[#2F3349] rounded-2xl p-6 hover:transform hover:scale-105 transition-all">
                    <div className="flex items-center justify-between mb-3">
                      <i className={`${metric.icon} text-2xl text-[#14B8A6]`}></i>
                      <span className="text-xs text-[#84CC16] font-semibold flex items-center gap-1">
                        <i className="ri-arrow-up-line"></i>
                        {metric.trend}
                      </span>
                    </div>
                    <div className="text-3xl font-bold text-white mb-1">{metric.value}</div>
                    <div className="text-sm text-gray-400">{metric.label}</div>
                  </div>
                ))}
              </div>

              <div className="grid lg:grid-cols-5 gap-6">
                <div className="lg:col-span-3 bg-[#2F3349] rounded-2xl p-6">
                  <h3 className="text-lg font-semibold text-white mb-6">Traffic Overview</h3>
                  <div className="relative h-64">
                    <svg className="w-full h-full" viewBox="0 0 400 200" preserveAspectRatio="none">
                      <defs>
                        <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                          <stop offset="0%" stopColor="#FF6B6B" stopOpacity="0.4" />
                          <stop offset="100%" stopColor="#14B8A6" stopOpacity="0.1" />
                        </linearGradient>
                      </defs>
                      <path
                        d="M 0 180 Q 50 160, 100 140 T 200 100 T 300 80 T 400 60 L 400 200 L 0 200 Z"
                        fill="url(#gradient)"
                      />
                      <path
                        d="M 0 180 Q 50 160, 100 140 T 200 100 T 300 80 T 400 60"
                        fill="none"
                        stroke="#FF6B6B"
                        strokeWidth="3"
                      />
                    </svg>
                  </div>
                </div>

                <div className="lg:col-span-2 bg-[#2F3349] rounded-2xl p-6">
                  <h3 className="text-lg font-semibold text-white mb-6">Top Keywords</h3>
                  <div className="space-y-4">
                    {keywords.map((item, index) => (
                      <div key={index} className="flex items-center justify-between">
                        <div className="flex-1">
                          <div className="text-sm text-white font-medium">{item.keyword}</div>
                        </div>
                        <div className="flex items-center gap-3">
                          <span className="text-lg font-bold text-[#14B8A6]">#{item.position}</span>
                          <div className="w-6 h-6 flex items-center justify-center">
                            {item.change === 'up' && (
                              <i className="ri-arrow-up-line text-[#84CC16]"></i>
                            )}
                            {item.change === 'down' && (
                              <i className="ri-arrow-down-line text-[#FF6B6B]"></i>
                            )}
                            {item.change === 'same' && (
                              <i className="ri-subtract-line text-gray-500"></i>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="mt-6 flex justify-end">
                <button className="bg-[#FF6B6B] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#FF5252] transition-all inline-flex items-center gap-2 whitespace-nowrap cursor-pointer">
                  Try Dashboard
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
